import { corpFacilityUserRole } from 'globals/global.constants';
import CorpFacilityUserModel from '../model/corporateListModel';
var CorpFacilityUsersParser = /** @class */ (function () {
    function CorpFacilityUsersParser() {
        this.agentList = [];
    }
    /**
     * @function normalizeAgencies
     * @description Normalizes the API's `agencies` array (whose `id` can be
     * either a plain string or `{id: string}`) into a clean `IAgency[]`.
     * Falls back to the legacy single `account_name`/`account_id` fields
     * when `agencies` isn't present, so older API responses still work.
     * @param {ICorpFacilityUserAPIData} userData
     * @returns {IAgency[]}
     */
    CorpFacilityUsersParser.prototype.normalizeAgencies = function (userData) {
        if (Array.isArray(userData.agencies) && userData.agencies.length) {
            return userData.agencies
                .filter(function (agency) { return agency && agency.name; })
                .map(function (agency) { return ({
                id: typeof agency.id === 'object' && agency.id !== null
                    ? agency.id.id
                    : agency.id,
                name: agency.name,
            }); });
        }
        if (userData.account_name) {
            return [{ id: userData.account_id, name: userData.account_name }];
        }
        return [];
    };
    /**
     * @description function to parse the response data
     * @function parse
     * @param {ICorpFacilityUserAPIData} data api response array data
     * @returns {ICorpFacilityUserAPIData[]} parsed data
     */
    CorpFacilityUsersParser.prototype.parse = function (data) {
        var _this = this;
        this.agentList = data.map(function (userData) {
            var _a, _b, _c;
            var agencies = _this.normalizeAgencies(userData);
            return new CorpFacilityUserModel(userData.id, {
                firstName: userData.first_name,
                lastName: userData.last_name,
            }, {
                street: userData === null || userData === void 0 ? void 0 : userData.address_state,
                city: userData === null || userData === void 0 ? void 0 : userData.address_city,
                state: userData === null || userData === void 0 ? void 0 : userData.address_state,
                postalCode: userData === null || userData === void 0 ? void 0 : userData.address_postalcode,
            }, ((_a = agencies[0]) === null || _a === void 0 ? void 0 : _a.name) || userData.account_name, ((_b = agencies[0]) === null || _b === void 0 ? void 0 : _b.id) || userData.account_id, userData.corporate_name, userData.corporate_id, (_c = corpFacilityUserRole[userData.role]) === null || _c === void 0 ? void 0 : _c.label, userData.email, userData.phone, userData.facility_type, userData.is_active, userData.is_first_login, agencies);
        });
        return this.agentList;
    };
    return CorpFacilityUsersParser;
}());
export default CorpFacilityUsersParser;
